import { render, staticRenderFns } from "./GlobalNav.vue?vue&type=template&id=6f7354dc&"
import script from "./GlobalNav.vue?vue&type=script&lang=js&"
export * from "./GlobalNav.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports